import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { bindActionCreators } from 'redux';

import { actions as navigationActions } from 'store/navigation';
import { actions as alertActions } from 'store/alert';
import { actions as modalActions } from 'store/modal';

export const useActions = () => {
  const dispatch = useDispatch();
  return useMemo(
    () => ({
      navigation: bindActionCreators(navigationActions, dispatch),
      alert: bindActionCreators(alertActions, dispatch),
      modal: bindActionCreators(modalActions, dispatch),
    }),
    [dispatch],
  );
};
